import { useCurrentConversationId } from 'features/messaging'
import { Redirect } from 'react-router-dom'

export function MailboxPage() {
	const id = useCurrentConversationId()

	return <Redirect to={`/messaging/thread/${id}`} />
}
